// material-ui
import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';

// project imports
import { RoleLevel } from '../../../../../../../domain/entities/Role';
import { useAuth } from '../../../../../../hooks/useAuth';
import menuItems from '../menu-items';
import NavGroup from './NavGroup';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
  const { user } = useAuth();
  let userRoleLevel = RoleLevel.Signatory;
  
  if(user?.role){
    userRoleLevel = user?.role?.level;
  }

  const siteConfigs = useSelector((state) => state.administrator.siteConfigs);

  const navItems = menuItems.items.filter(item => {
    if (item.level > userRoleLevel) return false;
    if (typeof item.hidden === 'function') {
      if (!siteConfigs?.siteConfigs) return false;
      if (item.hidden(siteConfigs.siteConfigs)) return false;
    }
    return true;
  }).map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });
  return <>{navItems}</>;
};

export default MenuList;
